import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Spinner,
  InputGroup,
} from "react-bootstrap";

export default function CustomerSelector({ apiBase = "/api", onSelect }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [newName, setNewName] = useState("");
  const [creating, setCreating] = useState(false);

  // Load customers on mount
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiBase}/customers/`);
      const data = await res.json();
      setCustomers(data);
    } catch (err) {
      console.error("Failed to load customers");
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (e) => {
    const id = e.target.value;
    setSelectedId(id);
    if (onSelect) onSelect(id);
  };

  const handleCreate = async () => {
    if (!newName.trim()) return;

    setCreating(true);
    try {
      const res = await fetch(`${apiBase}/customers/create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newName }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error("Failed to create");

      // Add to list + auto select
      setCustomers((prev) => [data, ...prev]);
      setSelectedId(data.id);
      setNewName("");

      if (onSelect) onSelect(data.id);
    } catch (err) {
      console.error(err);
    } finally {
      setCreating(false);
    }
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <h6 className="fw-semibold mb-3">Select Customer</h6>

        {loading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <Form.Select value={selectedId} onChange={handleSelect}>
            <option value="">-- Select Customer --</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </Form.Select>
        )}

        <hr />

        <Row className="g-2">
          <Col>
            <InputGroup>
              <Form.Control
                placeholder="New customer name"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
              <Button variant="dark" onClick={handleCreate} disabled={creating}>
                {creating ? <Spinner animation="border" size="sm" /> : "Add"}
              </Button>
            </InputGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
